import Box from '@mui/material/Box';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import { Delete } from '@mui/icons-material';

export default function TableActionBasic({ columns, values, handleDelete, handleEdit, t }) {
    return (
        <TableContainer sx={{ mt: 2, mb: 4 }}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align='center' style={{ width: 50 }} />
                        {columns.map((col, index) => <TableCell key={`tc-${index}`}>{col.label}</TableCell>)}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {values.map((item, idx) => (
                        <TableRow key={item.id} sx={{ height: 40 }}>
                            <TableCell align="center">
                                <Tooltip title={t("delete")}>
                                <IconButton size="small" color="error"
                                    onClick={() => handleDelete(item.id, idx)}
                                >
                                    <Delete fontSize="small" />
                                </IconButton>
                                </Tooltip>
                            </TableCell>
                            {columns.map((col, index) => <TableCell key={`td-${index}`}> <Typography variant="body2">{item[col.id]}</Typography> </TableCell>)}
                        </TableRow>
                    ))}
                </TableBody>

            </Table>
        </TableContainer>
    )
}